"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "job:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      addJobDialogVisible: false,
      updateJobFlag: false,
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        beanName: "",
        methodName: "",
        status: ""
      },
      addInformationParameter: {
        jobId: "",
        beanName: "",
        methodName: "",
        cronExpression: "",
        remark: "",
        params: "",
        status: ""
      },
      downloadLoading: false,
      multipleSelection: [],
      rules: {
        beanName: [{
          required: true,
          message: _lang.default.t("job.beanNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        methodName: [{
          required: true,
          message: _lang.default.t("job.methodNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        cronExpression: [{
          required: true,
          message: _lang.default.t("job.cronExpressionText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['TaskStatusOptions'])),
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this2 = this;

      //Set the loading button for table
      this.listLoading = true; //Get search parameters

      var params = this.getQueryParams();

      _httpUtils.default.post("job", "list", null, params).then(function (res) {
        _this2.list = res.data.rows;
        _this2.total = res.data.total;
      }).finally(function () {
        _this2.listLoading = false;
      });

      setTimeout(function () {
        _this2.listLoading = false;
      }, 1 * 1000);
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        beanName: this.queryParameter.beanName,
        methodName: this.queryParameter.methodName,
        status: this.queryParameter.status
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Fill in parameters for update task
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.jobId = row.jobId;
      this.addInformationParameter.beanName = row.beanName;
      this.addInformationParameter.methodName = row.methodName;
      this.addInformationParameter.cronExpression = row.cronExpression;
      this.addInformationParameter.remark = row.remark;
      this.addInformationParameter.params = row.params;
      this.addInformationParameter.status = row.status;
      this.addJobDialogVisible = true;
      this.updateJobFlag = true;
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        jobId: this.addInformationParameter.jobId,
        beanName: this.addInformationParameter.beanName,
        methodName: this.addInformationParameter.methodName,
        cronExpression: this.addInformationParameter.cronExpression,
        remark: this.addInformationParameter.remark,
        params: this.addInformationParameter.params,
        status: this.addInformationParameter.status
      };
    },
    updateJob: function updateJob(params) {
      var _this3 = this;

      this.listLoading = true;

      _httpUtils.default.post("job", "update", null, params).then(function (res) {
        if (res.code === 200) {
          _this3.$message({
            message: _lang.default.t("warningMessage.updateJobSuccessMessage"),
            type: "success"
          });
        } else {
          _this3.$message({
            message: res.message,
            type: "error"
          });
        }

        _this3.handleResetAdd();

        _this3.handleFilter();
      }).catch(function (error) {
        _this3.$message({
          message: error.message,
          type: 'error'
        });
      });

      setTimeout(function () {
        _this3.listLoading = false;
      }, 1 * 1000);
    },
    addJob: function addJob(params) {
      var _this4 = this;

      this.listLoading = true;

      _httpUtils.default.post("job", "add", null, params).then(function (res) {
        if (res.code == 200) {
          _this4.$message({
            message: _lang.default.t("warningMessage.addJobSuccessMessage"),
            type: "success"
          });
        }

        if (res.code == 500) {
          _this4.$message({
            message: res.message,
            type: "error"
          });
        }

        _this4.handleResetAdd();

        _this4.handleFilter();
      }).catch(function (err) {
        _this4.$message({
          message: err.message,
          type: "error"
        });
      });

      setTimeout(function () {
        _this4.listLoading = false;
      }, 1 * 1000);
    },
    handleAdd: function handleAdd() {
      var _this5 = this;

      var params = this.getAddInformationParameter();
      this.$refs["addInformation"].validate(function (valid) {
        if (valid) {
          if (_this5.updateJobFlag) {
            _this5.updateJob(params);
          } else {
            _this5.$confirm(_lang.default.t("warningMessage.addJobConfirmMessage"), _lang.default.t("job.addJobText"), {
              confirmButtonText: _lang.default.t("common.confirm"),
              cancelButtonText: _lang.default.t("common.cancel"),
              type: "warning"
            }).then(function () {
              _this5.addJob(params);
            }).catch(function (_) {});
          }
        } else {
          return false;
        }
      });
    },
    deleteJob: function deleteJob(jobIds) {
      var _this6 = this;

      this.listLoading = true;

      _httpUtils.default.post("job", "batchDelete", null, jobIds).then(function (res) {
        if (res.code == 200) {
          _this6.$message({
            message: _lang.default.t("warningMessage.deleteJobSuccessMessage"),
            type: "success"
          });
        }

        _this6.handleFilter();
      });

      setTimeout(function () {
        _this6.listLoading = false;
      }, 1 * 1000);
    },
    handleDelete: function handleDelete(jobId) {
      var _this7 = this;

      this.$confirm(_lang.default.t("warningMessage.deleteJobConfirmMessage"), _lang.default.t("job.deleteJobText"), {
        confirmButtonText: _lang.default.t("common.confirm"),
        cancelButtonText: _lang.default.t("common.cancel"),
        type: "warning"
      }).then(function () {
        var jobIds = [];
        jobIds.push(jobId);

        _this7.deleteJob(jobIds);
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this8 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectJobToDeleteMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.deleteJobConfirmMessage"), _lang.default.t("job.deleteJobText"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var jobIds = [];

          for (var item in _this.multipleSelection) {
            jobIds.push(_this.multipleSelection[item].jobId);
          }

          _this8.deleteJob(jobIds);
        }).catch(function (_) {});
      }
    },
    handlePause: function handlePause() {
      var _this9 = this;

      var _this = this;

      var jobIds = [];

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectJobToPauseMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.pauseJobConfirmMessage"), _lang.default.t("job.pauseJobText"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          for (var item in _this.multipleSelection) {
            jobIds.push(_this.multipleSelection[item].jobId);
          }

          _httpUtils.default.post("job", "pause", null, jobIds).then(function (res) {
            if (res.code == 200) {
              _this9.$message({
                message: _lang.default.t("warningMessage.pauseJobSuccessMessage"),
                type: "success"
              });
            }

            _this9.handleFilter();
          });
        }).catch(function (_) {});
      }
    },
    handleResume: function handleResume() {
      var _this10 = this;

      var _this = this;

      var jobIds = [];

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectJobToResumeMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.resumeJobConfirmMessage"), _lang.default.t("job.resumeJobText"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          for (var item in _this.multipleSelection) {
            jobIds.push(_this.multipleSelection[item].jobId);
          }

          _httpUtils.default.post("job", "resume", null, jobIds).then(function (res) {
            if (res.code == 200) {
              _this10.$message({
                message: _lang.default.t("warningMessage.resumeJobSuccessMessage"),
                type: "success"
              });
            }

            _this10.handleFilter();
          });
        }).catch(function (_) {});
      }
    },
    handleRun: function handleRun() {
      var _this11 = this;

      var _this = this;

      var jobIds = [];

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectJobToRunMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.runJobConfirmMessage"), _lang.default.t("job.runJobText"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          for (var item in _this.multipleSelection) {
            jobIds.push(_this.multipleSelection[item].jobId);
          }

          _httpUtils.default.post("job", "run", null, jobIds).then(function (res) {
            if (res.code == 200) {
              _this11.$message({
                message: _lang.default.t("warningMessage.runJobSuccessMessage"),
                type: "success"
              });
            }

            _this11.handleFilter();
          });
        }).catch(function (_) {});
      }
    },
    handleExportExcel: function handleExportExcel() {
      var excelName = _lang.default.t("job.scheduledTaskExcelText");

      var params = this.getQueryParams();

      _httpUtils.default.getByBlob("job", "excel", params, excelName);

      this.$message({
        message: _lang.default.t("warningMessage.pleaseWaitForExportMessage"),
        type: "info",
        showClose: true
      });
    },
    //Clear input parameters
    handleReset: function handleReset() {
      this.addInformationParameter.jobId = "";
      this.addInformationParameter.beanName = "";
      this.addInformationParameter.methodName = "";
      this.addInformationParameter.params = "";
      this.addInformationParameter.cronExpression = "";
      this.addInformationParameter.remark = "";
      this.addInformationParameter.status = "";
    },
    //Reset validate for input parameters
    handleResetAdd: function handleResetAdd() {
      var _this12 = this;

      this.handleReset();
      this.updateJobFlag = false;
      this.addJobDialogVisible = false;
      this.$nextTick(function (_) {
        _this12.$refs["addInformation"].clearValidate();
      });
    },
    convertStatusOptionName: function convertStatusOptionName(name) {
      var found = "";
      this.TaskStatusOptions.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;